const useChangeColors = (change: number) => {
  let textColor: string
  let bgColor: string

  switch (true) {
    case change > 0.000049:
      textColor = "text-green-400"
      bgColor = "bg-green-400"
      break
    case change < -0.000049:
      textColor = "text-red-400"
      bgColor = "bg-red-400"
      break
    default:
      textColor = "text-gray-600"
      bgColor = "bg-gray-600"
  }

  return { textColor, bgColor }
}

export default useChangeColors
